module.exports = __webpack_public_path__ + "img/SD.920b1379.svg";